import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LanguageSwitcher from '../components/LanguageSwitcher';
import '../styles/Portfolio.css';

import project1 from '../assets/1.png';
import project2 from '../assets/2.png';
import project3 from '../assets/3.png';
import project4 from '../assets/4.png';
import project5 from '../assets/5.png';
import project6 from '../assets/6.png';
import project7 from '../assets/7.png';
import loading from '../assets/loading.png';

const Portfolio = () => {
  const { t } = useTranslation();
  const [activeFilter, setActiveFilter] = useState('all');

  // Projets (à remplacer par tes vrais projets)
  const projects = [
    {
      id: 1,
      title: 'OneStoreOrient',
      category: 'web',
      image: project3,
      tags: ['Wordpress', 'WooCommerce'],
      link: 'https://onestoreorient.com/',
      featured: false
    },
    {
      id: 2,
      title: 'Drivematch - Never Drive Alone',
      category: 'mobile',
      image: project2,
      tags: ['React Native', 'NodeJS', 'MongoDB', 'iOS', 'Android'],
      link: 'https://drivematch.app/',
      featured: true
    },
    {
      id: 3,
      title: 'Graphi-Kai',
      category: 'both',
      image: project1,
      tags: ['ReactJS', 'React Native', 'NodeJs', 'MongoDB', 'iOS', 'Android'],
      link: 'https://apps.apple.com/fr/app/graphikai/id6755329159',
      featured: false
    },
      {
      id: 4,
      title: 'SaltyRace',
      category: 'web',
      image: project4,
      tags: ['ReactJS', 'NodeJS', 'MongoDB'],
      link: 'https://saltyrace.com/',
      featured: true
    },
         {
      id: 5,
      title: 'Memo Word',
      category: 'mobile',
      image: project5,
      tags: ['React Native', 'NodeJS', 'MongoDB', 'iOS'],
      link: 'https://apps.apple.com/fr/app/memoword/id6756536121',
      featured: false
    },
         {
      id: 6,
      title: 'Association de Solidarité International France-Comores',
      category: 'web',
      image: project6,
      tags: ['ReactJS', 'NodeJS', 'MongoDB'],
      link: 'https://asifc.fr/',
      featured: false
    },
             {
      id: 7,
      title: 'MHDT - Mes Heures De Taf',
      category: 'mobile',
      image: project7,
      tags: ['React native', 'NodeJS', 'MongoDB', 'iOS', 'Android'],
      link: 'https://apps.apple.com/fr/app/mhdt-mes-heures-de-taf/id6757674415',
      featured: false
    },
          {
      id: 8,
      title: t('portfolio.underConstruction') || 'En cours de construction...',
      category: 'web',
      image: loading,
      tags: ['ReactJS', 'NodeJS', 'MongoDB'],
      link: '#',
      featured: false
    },
  ];

  const filters = [
    { value: 'all', label: t('portfolio.filter.all') || 'Tous' },
    { value: 'web', label: t('portfolio.filter.web') || 'Web' },
    { value: 'mobile', label: t('portfolio.filter.mobile') || 'Mobile' },
    { value: 'both', label: t('portfolio.filter.both') || 'Web + Mobile' }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(p => p.category === activeFilter);

  const getCategoryIcon = (category) => {
    const icons = {
      web: '🌐',
      mobile: '📱',
      both: '🚀'
    };
    return icons[category] || '💼';
  };

  const getCategoryLabel = (category) => {
    const labels = {
      web: 'Web',
      mobile: 'Mobile',
      both: 'Web + Mobile'
    };
    return labels[category] || category;
  };

  return (
    <div className="portfolio-container">
      {/* <LanguageSwitcher /> */}

      {/* Header */}
      <header className="portfolio-header">
        
        <div className="header-content">
          <h1 className="portfolio-title">
            {t('portfolio.title') || 'Mes Projets'}
          </h1>
          <p className="portfolio-subtitle">
            {t('portfolio.subtitle') || 'Découvrez quelques réalisations que j\'ai développées'}
          </p>
        </div>
      </header>

      {/* Filters */}
      <div className="filters-container">
        <div className="filters">
          {filters.map(filter => (
            <button
              key={filter.value}
              onClick={() => setActiveFilter(filter.value)}
              className={`filter-btn ${activeFilter === filter.value ? 'active' : ''}`}
            >
              {filter.label}
            </button>
          ))}
        </div>
        
      </div>

      {/* Projects Grid */}
      <div className="projects-grid">
        {filteredProjects.map((project, index) => (
          <div 
            key={project.id} 
            className={`project-card ${project.featured ? 'featured' : ''}`}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            {project.featured && (
              <div className="featured-badge">
                ⭐
              </div>
            )}
            
            <div className="project-image-container">
              <img 
                src={project.image} 
                alt={project.title}
                className="project-image"
              />
              <div className="project-overlay">
                <span className="category-badge">
                  {getCategoryIcon(project.category)} {getCategoryLabel(project.category)}
                </span>
              </div>
            </div>

            <div className="project-content">
              <h3 className="project-title">{project.title}</h3>
              {/* <p className="project-description">{project.description}</p> */}
              
              <div className="project-tags">
                {project.tags.map(tag => (
                  <span key={tag} className="project-tag">
                    {tag}
                  </span>
                ))}
              </div>
              

                {project.title !== 'En cours de construction...' && project.title !== t('portfolio.underConstruction') && (
                    <a 
                      href={project.link} 
                      className="project-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    > 
                      {t('portfolio.viewProject') || 'Voir le projet'} →
                    </a>
                )}
           
            </div>
          </div>
        ))}
      </div>

      {/* CTA Section */}
      <section className="portfolio-cta">
        <h2>{t('portfolio.cta.title') || 'Un projet en tête ?'}</h2>
        <p>{t('portfolio.cta.description') || 'Discutons de votre idée et donnons-lui vie ensemble'}</p>
        <div className="cta-buttons">
          <Link to="/contact-client" className="cta-btn primary">
            💼 {t('portfolio.cta.button') || 'Demander un devis'}
          </Link>
          <Link to="/" className="cta-btn secondary">
            🏠 {t('portfolio.cta.home') || 'Retour à l\'accueil'}
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;